var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
            "margin-bottom": "10px",
          },
        },
        [
          _c("h2", { staticStyle: { margin: "0" } }, [
            _vm._v("Business Analytics"),
          ]),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                icon: "el-icon-download",
                size: "small",
              },
              on: {
                click: function ($event) {
                  _vm.showExportDialog = true
                },
              },
            },
            [_vm._v("Export Excel")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Export Business Analytics",
            visible: _vm.showExportDialog,
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExportDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Date Range" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "Start",
                      "end-placeholder": "End",
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                    },
                    model: {
                      value: _vm.exportDateRange,
                      callback: function ($$v) {
                        _vm.exportDateRange = $$v
                      },
                      expression: "exportDateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Period" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        size: "small",
                        disabled:
                          !_vm.exportDateRange ||
                          _vm.exportDateRange.length < 2,
                      },
                      model: {
                        value: _vm.exportGroupBy,
                        callback: function ($$v) {
                          _vm.exportGroupBy = $$v
                        },
                        expression: "exportGroupBy",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "Daily",
                          value: "day",
                          disabled: _vm.exportDaySpan > 90,
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "Weekly", value: "week" },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Monthly",
                          value: "month",
                          disabled: _vm.exportDaySpan < 28,
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Quarterly",
                          value: "quarter",
                          disabled: _vm.exportDaySpan < 85,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.exportDateRange && _vm.exportDateRange.length === 2
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#909399",
                            "margin-top": "4px",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.exportDaySpan) + " days selected "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tabs" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.exportTabs,
                        callback: function ($$v) {
                          _vm.exportTabs = $$v
                        },
                        expression: "exportTabs",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "smart-map" } }, [
                        _vm._v("Smart Map Users"),
                      ]),
                      _c(
                        "el-checkbox",
                        { attrs: { label: "voice-assistant" } },
                        [_vm._v("Voice Assistant Users")]
                      ),
                      _c("el-checkbox", { attrs: { label: "weassist" } }, [
                        _vm._v("WeAssist Users"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showExportDialog = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exportLoading,
                    disabled:
                      !_vm.exportDateRange ||
                      _vm.exportDateRange.length < 2 ||
                      _vm.exportTabs.length === 0,
                  },
                  on: { click: _vm.exportToExcel },
                },
                [_vm._v("Export")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Smart Map Users", name: "smart-map" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("i", {
                              staticClass: "el-icon-location stat-icon",
                              staticStyle: { color: "#409eff" },
                            }),
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Smart Map Users"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(
                                  _vm._s(_vm.smartMapData.summary?.total || 0)
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("By Source")])]
                          ),
                          _vm.smartMapData.summary?.bySource?.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      staticStyle: { display: "inline" },
                                      attrs: { size: "small" },
                                      on: {
                                        change: _vm.onSmartMapSourceChange,
                                      },
                                      model: {
                                        value: _vm.smartMapSourceFilters,
                                        callback: function ($$v) {
                                          _vm.smartMapSourceFilters = $$v
                                        },
                                        expression: "smartMapSourceFilters",
                                      },
                                    },
                                    _vm._l(
                                      _vm.smartMapData.summary.bySource,
                                      function (item) {
                                        return _c(
                                          "el-checkbox-button",
                                          {
                                            key: item.real_source,
                                            attrs: { label: item.real_source },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatSourceType(
                                                    item.real_source
                                                  )
                                                ) +
                                                ": " +
                                                _vm._s(item.count) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                  _vm.smartMapSourceFilters.length
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            "margin-left": "8px",
                                            cursor: "pointer",
                                          },
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.smartMapSourceFilters = []
                                              _vm.onSmartMapSourceChange()
                                            },
                                          },
                                        },
                                        [_vm._v("Clear")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c("el-empty", {
                                attrs: {
                                  description: "No data",
                                  "image-size": 60,
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("strong", [_vm._v("Smart Map Users List")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "10px",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "date",
                              placeholder: "Start Date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.handleSmartMapDateChange },
                            model: {
                              value: _vm.smartMapStartDate,
                              callback: function ($$v) {
                                _vm.smartMapStartDate = $$v
                              },
                              expression: "smartMapStartDate",
                            },
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "date",
                              placeholder: "End Date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.handleSmartMapDateChange },
                            model: {
                              value: _vm.smartMapEndDate,
                              callback: function ($$v) {
                                _vm.smartMapEndDate = $$v
                              },
                              expression: "smartMapEndDate",
                            },
                          }),
                          _c("el-input", {
                            staticStyle: { width: "280px" },
                            attrs: {
                              placeholder:
                                "Search name, email, phone, serial...",
                              "prefix-icon": "el-icon-search",
                              clearable: "",
                              size: "small",
                            },
                            on: { input: _vm.handleSmartMapSearch },
                            model: {
                              value: _vm.smartMapSearch,
                              callback: function ($$v) {
                                _vm.smartMapSearch = $$v
                              },
                              expression: "smartMapSearch",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                icon: "el-icon-download",
                                size: "small",
                                loading: _vm.smartMapExporting,
                              },
                              on: { click: _vm.exportSmartMap },
                            },
                            [_vm._v("Export Excel")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.smartMapLoading,
                          expression: "smartMapLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.smartMapData.users,
                        border: "",
                        stripe: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Name", "min-width": "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      [row.first_name, row.last_name]
                                        .filter(Boolean)
                                        .join(" ") || "-"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "email",
                          label: "Email",
                          "min-width": "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.email || "-"))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "phone_number",
                          label: "Phone",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.phone_number || "-"))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "real_source",
                          label: "Source",
                          width: "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getSourceTagType(
                                        row.real_source || row.source_type
                                      ),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatSourceType(
                                            row.real_source || row.source_type
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "connected_device_serial",
                          label: "Device",
                          width: "180",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.connected_device_serial
                                  ? _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          "font-family": "monospace",
                                          "font-size": "12px",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDeviceDetail(
                                              row.connected_device_serial
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.connected_device_serial
                                            ) +
                                            " "
                                        ),
                                        row.device_type
                                          ? _c(
                                              "el-tag",
                                              {
                                                staticStyle: {
                                                  "margin-left": "4px",
                                                },
                                                attrs: {
                                                  type:
                                                    row.device_type === "V2"
                                                      ? "success"
                                                      : "primary",
                                                  size: "mini",
                                                },
                                              },
                                              [_vm._v(_vm._s(row.device_type))]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "start_date",
                          label: "Start Date",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(_vm._s(_vm.formatDate(row.start_date))),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "end_date",
                          label: "End Date",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(_vm._s(_vm.formatDate(row.end_date))),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "15px",
                      "text-align": "right",
                    },
                    attrs: {
                      "current-page": _vm.smartMapPage,
                      "page-size": _vm.smartMapLimit,
                      total: _vm.smartMapData.pagination?.total || 0,
                      "page-sizes": [20, 50, 100],
                      layout: "total, sizes, prev, pager, next",
                    },
                    on: {
                      "size-change": _vm.handleSmartMapSizeChange,
                      "current-change": _vm.handleSmartMapPageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "Voice Assistant Users",
                name: "voice-assistant",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("i", {
                              staticClass: "el-icon-microphone stat-icon",
                              staticStyle: { color: "#722ed1" },
                            }),
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Voice Assistant Users"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(_vm._s(_vm.vaData.summary?.total || 0)),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("By Source")])]
                          ),
                          _vm.vaData.summary?.bySource?.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      staticStyle: { display: "inline" },
                                      attrs: { size: "small" },
                                      on: { change: _vm.onVaSourceChange },
                                      model: {
                                        value: _vm.vaSourceFilters,
                                        callback: function ($$v) {
                                          _vm.vaSourceFilters = $$v
                                        },
                                        expression: "vaSourceFilters",
                                      },
                                    },
                                    _vm._l(
                                      _vm.vaData.summary.bySource,
                                      function (item) {
                                        return _c(
                                          "el-checkbox-button",
                                          {
                                            key: item.real_source,
                                            attrs: { label: item.real_source },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatSourceType(
                                                    item.real_source
                                                  )
                                                ) +
                                                ": " +
                                                _vm._s(item.count) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                  _vm.vaSourceFilters.length
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            "margin-left": "8px",
                                            cursor: "pointer",
                                          },
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.vaSourceFilters = []
                                              _vm.onVaSourceChange()
                                            },
                                          },
                                        },
                                        [_vm._v("Clear")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c("el-empty", {
                                attrs: {
                                  description: "No data",
                                  "image-size": 60,
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("strong", [_vm._v("Voice Assistant Users List")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "10px",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "date",
                              placeholder: "Start Date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.handleVaDateChange },
                            model: {
                              value: _vm.vaStartDate,
                              callback: function ($$v) {
                                _vm.vaStartDate = $$v
                              },
                              expression: "vaStartDate",
                            },
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "date",
                              placeholder: "End Date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.handleVaDateChange },
                            model: {
                              value: _vm.vaEndDate,
                              callback: function ($$v) {
                                _vm.vaEndDate = $$v
                              },
                              expression: "vaEndDate",
                            },
                          }),
                          _c("el-input", {
                            staticStyle: { width: "280px" },
                            attrs: {
                              placeholder:
                                "Search name, email, phone, serial...",
                              "prefix-icon": "el-icon-search",
                              clearable: "",
                              size: "small",
                            },
                            on: { input: _vm.handleVaSearch },
                            model: {
                              value: _vm.vaSearch,
                              callback: function ($$v) {
                                _vm.vaSearch = $$v
                              },
                              expression: "vaSearch",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                icon: "el-icon-download",
                                size: "small",
                                loading: _vm.vaExporting,
                              },
                              on: { click: _vm.exportVaUsers },
                            },
                            [_vm._v("Export Excel")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.vaLoading,
                          expression: "vaLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.vaData.users,
                        border: "",
                        stripe: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Name", "min-width": "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    [row.first_name, row.last_name]
                                      .filter(Boolean)
                                      .join(" ") || "-"
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "email",
                          label: "Email",
                          "min-width": "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.email || "-"))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "phone_number",
                          label: "Phone",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.phone_number || "-"))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "real_source",
                          label: "Source",
                          width: "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getSourceTagType(
                                        row.real_source || row.source_type
                                      ),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatSourceType(
                                          row.real_source || row.source_type
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "connected_device_serial",
                          label: "Device",
                          width: "180",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.connected_device_serial
                                  ? _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          "font-family": "monospace",
                                          "font-size": "12px",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDeviceDetail(
                                              row.connected_device_serial
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.connected_device_serial
                                            ) +
                                            " "
                                        ),
                                        row.device_type
                                          ? _c(
                                              "el-tag",
                                              {
                                                staticStyle: {
                                                  "margin-left": "4px",
                                                },
                                                attrs: {
                                                  type:
                                                    row.device_type === "V2"
                                                      ? "success"
                                                      : "primary",
                                                  size: "mini",
                                                },
                                              },
                                              [_vm._v(_vm._s(row.device_type))]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "start_date",
                          label: "Start Date",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(_vm._s(_vm.formatDate(row.start_date))),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "end_date",
                          label: "End Date",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(_vm._s(_vm.formatDate(row.end_date))),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "15px",
                      "text-align": "right",
                    },
                    attrs: {
                      "current-page": _vm.vaPage,
                      "page-size": _vm.vaLimit,
                      total: _vm.vaData.pagination?.total || 0,
                      "page-sizes": [20, 50, 100],
                      layout: "total, sizes, prev, pager, next",
                    },
                    on: {
                      "size-change": (s) => {
                        _vm.vaLimit = s
                        _vm.vaPage = 1
                        _vm.loadVaUsers()
                      },
                      "current-change": (p) => {
                        _vm.vaPage = p
                        _vm.loadVaUsers()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "WeAssist", name: "weassist" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("i", {
                              staticClass: "el-icon-phone-outline stat-icon",
                              staticStyle: { color: "#13c2c2" },
                            }),
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total WeAssist Users"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(
                                  _vm._s(_vm.weassistData.summary?.total || 0)
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("By Platform")])]
                          ),
                          _vm.weassistData.summary?.byPlatform?.length
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.weassistData.summary.byPlatform,
                                  function (item) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: item.platform,
                                        staticStyle: { margin: "4px" },
                                        attrs: {
                                          type:
                                            item.platform === "ios"
                                              ? "primary"
                                              : item.platform === "android"
                                              ? "success"
                                              : "warning",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.platform) +
                                            ": " +
                                            _vm._s(item.count) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _c("el-empty", {
                                attrs: {
                                  description: "No data",
                                  "image-size": 60,
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("strong", [_vm._v("WeAssist Users List")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "10px",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "date",
                              placeholder: "Start Date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.handleWeassistDateChange },
                            model: {
                              value: _vm.weassistStartDate,
                              callback: function ($$v) {
                                _vm.weassistStartDate = $$v
                              },
                              expression: "weassistStartDate",
                            },
                          }),
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "date",
                              placeholder: "End Date",
                              "value-format": "yyyy-MM-dd",
                              size: "small",
                            },
                            on: { change: _vm.handleWeassistDateChange },
                            model: {
                              value: _vm.weassistEndDate,
                              callback: function ($$v) {
                                _vm.weassistEndDate = $$v
                              },
                              expression: "weassistEndDate",
                            },
                          }),
                          _c("el-input", {
                            staticStyle: { width: "280px" },
                            attrs: {
                              placeholder: "Search name, email, phone...",
                              "prefix-icon": "el-icon-search",
                              clearable: "",
                              size: "small",
                            },
                            on: { input: _vm.handleWeassistSearch },
                            model: {
                              value: _vm.weassistSearch,
                              callback: function ($$v) {
                                _vm.weassistSearch = $$v
                              },
                              expression: "weassistSearch",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                icon: "el-icon-download",
                                size: "small",
                                loading: _vm.weassistExporting,
                              },
                              on: { click: _vm.exportWeassistUsers },
                            },
                            [_vm._v("Export Excel")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.weassistLoading,
                          expression: "weassistLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.weassistData.users,
                        border: "",
                        stripe: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Name", "min-width": "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    [row.first_name, row.last_name]
                                      .filter(Boolean)
                                      .join(" ") || "-"
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "email",
                          label: "Email",
                          "min-width": "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.email || "-"))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "phone_number",
                          label: "Phone",
                          width: "130",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.phone_number || "-"))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "product_name",
                          label: "Package",
                          width: "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.product_name || "-"))]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "platform",
                          label: "Platform",
                          width: "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.platform
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            row.platform === "ios"
                                              ? "primary"
                                              : row.platform === "android"
                                              ? "success"
                                              : "warning",
                                          size: "small",
                                        },
                                      },
                                      [_vm._v(_vm._s(row.platform))]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "total_minutes",
                          label: "Total Min",
                          width: "90",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "used_minutes",
                          label: "Used Min",
                          width: "90",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "remaining_minutes",
                          label: "Remaining",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      color:
                                        (row.remaining_minutes || 0) <= 0
                                          ? "#f56c6c"
                                          : (row.remaining_minutes || 0) <= 10
                                          ? "#e6a23c"
                                          : "#67c23a",
                                      fontWeight: "bold",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(row.remaining_minutes || 0) +
                                        " min "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "expires_date",
                          label: "Expires",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.formatDate(row.expires_date))
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "15px",
                      "text-align": "right",
                    },
                    attrs: {
                      "current-page": _vm.weassistPage,
                      "page-size": _vm.weassistLimit,
                      total: _vm.weassistData.pagination?.total || 0,
                      "page-sizes": [20, 50, 100],
                      layout: "total, sizes, prev, pager, next",
                    },
                    on: {
                      "size-change": (s) => {
                        _vm.weassistLimit = s
                        _vm.weassistPage = 1
                        _vm.loadWeassistUsers()
                      },
                      "current-change": (p) => {
                        _vm.weassistPage = p
                        _vm.loadWeassistUsers()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Purchase Analytics", name: "purchases" } },
            [
              _c(
                "div",
                {
                  staticClass: "filter-container",
                  staticStyle: { "margin-bottom": "15px" },
                },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "150px" },
                    attrs: {
                      type: "date",
                      placeholder: "Start Date",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.purchaseStartDate,
                      callback: function ($$v) {
                        _vm.purchaseStartDate = $$v
                      },
                      expression: "purchaseStartDate",
                    },
                  }),
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "150px" },
                    attrs: {
                      type: "date",
                      placeholder: "End Date",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.purchaseEndDate,
                      callback: function ($$v) {
                        _vm.purchaseEndDate = $$v
                      },
                      expression: "purchaseEndDate",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.loadPurchaseAnalytics },
                    },
                    [_vm._v("Search")]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Purchases"),
                              ]),
                              _c("div", { staticClass: "stat-value" }, [
                                _vm._v(_vm._s(_vm.purchaseTotals.total)),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("New Purchases"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-value",
                                  staticStyle: { color: "#67c23a" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.purchaseTotals.newPurchases)
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Renewals"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-value",
                                  staticStyle: { color: "#409eff" },
                                },
                                [_vm._v(_vm._s(_vm.purchaseTotals.renewals))]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v("Total Revenue"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-value",
                                  staticStyle: { color: "#e6a23c" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.purchaseTotals.revenue.toFixed(2)
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("By Product")])]
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.purchaseLoading,
                                  expression: "purchaseLoading",
                                },
                              ],
                              attrs: {
                                data: _vm.purchaseData.byProduct,
                                border: "",
                                stripe: "",
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "product_name",
                                  label: "Product",
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              row.product_name || row.product_id
                                            )
                                          ),
                                        ]),
                                        row.product_id
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "font-size": "11px",
                                                  color: "#999",
                                                },
                                              },
                                              [_vm._v(_vm._s(row.product_id))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "product_type",
                                  label: "Type",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          { attrs: { size: "small" } },
                                          [_vm._v(_vm._s(row.product_type))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "new_purchases",
                                  label: "New",
                                  width: "80",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#67c23a",
                                              "font-weight": "bold",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.new_purchases))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "renewals",
                                  label: "Renewals",
                                  width: "90",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#409eff",
                                              "font-weight": "bold",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.renewals))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "total",
                                  label: "Total",
                                  width: "80",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "revenue",
                                  label: "Revenue",
                                  width: "120",
                                  align: "right",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              parseFloat(row.revenue).toFixed(2)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("By Platform")])]
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.purchaseLoading,
                                  expression: "purchaseLoading",
                                },
                              ],
                              attrs: {
                                data: _vm.purchaseData.byPlatform,
                                border: "",
                                stripe: "",
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "platform",
                                  label: "Platform",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                row.platform === "android"
                                                  ? "success"
                                                  : "primary",
                                              size: "small",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(row.platform) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "new_purchases",
                                  label: "New",
                                  width: "70",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#67c23a",
                                              "font-weight": "bold",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.new_purchases))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "renewals",
                                  label: "Renewals",
                                  width: "80",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#409eff",
                                              "font-weight": "bold",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.renewals))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "total",
                                  label: "Total",
                                  width: "70",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "revenue",
                                  label: "Revenue",
                                  width: "100",
                                  align: "right",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              parseFloat(row.revenue).toFixed(2)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Device Analytics", name: "devices" } },
            [
              _c(
                "div",
                {
                  staticClass: "filter-container",
                  staticStyle: { "margin-bottom": "15px" },
                },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "150px" },
                    attrs: {
                      type: "date",
                      placeholder: "Start Date",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.deviceStartDate,
                      callback: function ($$v) {
                        _vm.deviceStartDate = $$v
                      },
                      expression: "deviceStartDate",
                    },
                  }),
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "150px" },
                    attrs: {
                      type: "date",
                      placeholder: "End Date",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.deviceEndDate,
                      callback: function ($$v) {
                        _vm.deviceEndDate = $$v
                      },
                      expression: "deviceEndDate",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.loadDeviceAnalytics },
                    },
                    [_vm._v("Search")]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-card", { attrs: { shadow: "hover" } }, [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("strong", [
                              _vm._v("Connected Devices (Current)"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "stat-grid" },
                          [
                            _vm._l(_vm.deviceData.connected, function (item) {
                              return _c(
                                "div",
                                {
                                  key: "c-" + item.product_type,
                                  staticClass: "stat-grid-item",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "stat-grid-label" },
                                    [_vm._v(_vm._s(item.product_type))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "stat-grid-value" },
                                    [_vm._v(_vm._s(item.count))]
                                  ),
                                ]
                              )
                            }),
                            _c("div", { staticClass: "stat-grid-item" }, [
                              _c("div", { staticClass: "stat-grid-label" }, [
                                _vm._v("Total"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-grid-value",
                                  staticStyle: { color: "#409eff" },
                                },
                                [_vm._v(_vm._s(_vm.connectedTotal))]
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-card", { attrs: { shadow: "hover" } }, [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("strong", [
                              _vm._v("Activated Devices (All Time)"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "stat-grid" },
                          [
                            _vm._l(_vm.deviceData.activated, function (item) {
                              return _c(
                                "div",
                                {
                                  key: "a-" + item.product_type,
                                  staticClass: "stat-grid-item",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "stat-grid-label" },
                                    [_vm._v(_vm._s(item.product_type))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "stat-grid-value" },
                                    [_vm._v(_vm._s(item.count))]
                                  ),
                                ]
                              )
                            }),
                            _c("div", { staticClass: "stat-grid-item" }, [
                              _c("div", { staticClass: "stat-grid-label" }, [
                                _vm._v("Total"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-grid-value",
                                  staticStyle: { color: "#67c23a" },
                                },
                                [_vm._v(_vm._s(_vm.activatedTotal))]
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("Connection Trend")])]
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.deviceLoading,
                                  expression: "deviceLoading",
                                },
                              ],
                              attrs: {
                                data: _vm.deviceData.connectionTrend,
                                border: "",
                                stripe: "",
                                size: "small",
                                "max-height": "400",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "date",
                                  label: "Date",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          _vm._s(_vm.formatDateShort(row.date))
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "product_type",
                                  label: "Type",
                                  width: "80",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                row.product_type === "V2"
                                                  ? "success"
                                                  : "primary",
                                              size: "small",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.product_type))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "count",
                                  label: "Count",
                                  width: "80",
                                  align: "center",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        { attrs: { shadow: "hover" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("Activation Trend")])]
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.deviceLoading,
                                  expression: "deviceLoading",
                                },
                              ],
                              attrs: {
                                data: _vm.deviceData.activationTrend,
                                border: "",
                                stripe: "",
                                size: "small",
                                "max-height": "400",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "date",
                                  label: "Date",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          _vm._s(_vm.formatDateShort(row.date))
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "product_type",
                                  label: "Type",
                                  width: "80",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                row.product_type === "V2"
                                                  ? "success"
                                                  : "primary",
                                              size: "small",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.product_type))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "count",
                                  label: "Count",
                                  width: "80",
                                  align: "center",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: { label: "Replacements & Returns", name: "replacements" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "filter-container",
                  staticStyle: { "margin-bottom": "15px" },
                },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "150px" },
                    attrs: {
                      type: "date",
                      placeholder: "Start Date",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.replacementStartDate,
                      callback: function ($$v) {
                        _vm.replacementStartDate = $$v
                      },
                      expression: "replacementStartDate",
                    },
                  }),
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "150px" },
                    attrs: {
                      type: "date",
                      placeholder: "End Date",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.replacementEndDate,
                      callback: function ($$v) {
                        _vm.replacementEndDate = $$v
                      },
                      expression: "replacementEndDate",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.loadReplacements },
                    },
                    [_vm._v("Search")]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { gutter: 20 },
                },
                _vm._l(["REPLACED", "REFUNDED", "REPAIR"], function (status) {
                  return _c(
                    "el-col",
                    { key: status, attrs: { span: 8 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "stat-card",
                          attrs: { shadow: "hover" },
                        },
                        [
                          _c("div", { staticClass: "stat-content" }, [
                            _c("div", { staticClass: "stat-info" }, [
                              _c("div", { staticClass: "stat-label" }, [
                                _vm._v(_vm._s(status)),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "stat-value",
                                  style: { color: _vm.getStatusColor(status) },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getStatusCount(status)) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "stat-sub" },
                                _vm._l(
                                  _vm.getStatusByType(status),
                                  function (item) {
                                    return _c(
                                      "span",
                                      {
                                        key: item.product_type,
                                        staticStyle: { "margin-right": "8px" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.product_type) +
                                            ": " +
                                            _vm._s(item.count) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "el-card",
                { attrs: { shadow: "hover" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("strong", [_vm._v("Recent Events")]),
                  ]),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.replacementLoading,
                          expression: "replacementLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.replacementData.recentEvents,
                        border: "",
                        stripe: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "serial_number",
                          label: "Serial Number",
                          width: "180",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "font-family": "monospace" },
                                  },
                                  [_vm._v(_vm._s(row.serial_number))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "product_type",
                          label: "Type",
                          width: "80",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.product_type === "V2"
                                          ? "success"
                                          : "primary",
                                      size: "small",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.product_type))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "event_type",
                          label: "Event",
                          width: "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getEventTagType(row.event_type),
                                      size: "small",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.event_type))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "event_date",
                          label: "Date",
                          width: "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(_vm._s(_vm.formatDate(row.event_date))),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "user_id",
                          label: "User ID",
                          width: "280",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-family": "monospace",
                                      "font-size": "12px",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.user_id || "-"))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "notes",
                          label: "Notes",
                          "min-width": "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(row.notes || "-"))]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Device Details",
            visible: _vm.deviceDetailVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deviceDetailVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.deviceDetailLoading,
                  expression: "deviceDetailLoading",
                },
              ],
            },
            [
              _vm.deviceDetailData
                ? _c(
                    "el-descriptions",
                    { attrs: { column: 2, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Serial Number" } },
                        [
                          _c("el-tag", [
                            _vm._v(
                              _vm._s(
                                _vm.deviceDetailData.serial_number ||
                                  _vm.deviceDetailData.serialNumber
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Product Type" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  (_vm.deviceDetailData.product_type ||
                                    _vm.deviceDetailData.productType) === "V2"
                                    ? "success"
                                    : "primary",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.deviceDetailData.product_type ||
                                      _vm.deviceDetailData.productType
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Purchase Type" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.deviceDetailData.purchase_type ||
                                _vm.deviceDetailData.purchaseType ||
                                "N/A"
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Lifecycle Status" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  _vm.deviceDetailData.lifecycle_status ===
                                  "ACTIVE"
                                    ? "success"
                                    : _vm.deviceDetailData.lifecycle_status ===
                                      "REFUNDED"
                                    ? "danger"
                                    : "warning",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.deviceDetailData.lifecycle_status ||
                                      _vm.deviceDetailData.lifecycleStatus
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Current User", span: 2 } },
                        [
                          _vm.deviceDetailData.current_user_id ||
                          _vm.deviceDetailData.currentUserId
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.deviceDetailData.current_user_id ||
                                      _vm.deviceDetailData.currentUserId
                                  )
                                ),
                              ])
                            : _c(
                                "el-tag",
                                { attrs: { type: "info", size: "small" } },
                                [_vm._v("Not Connected")]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Activation Date" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.activation_date ||
                                  _vm.deviceDetailData.activationDate
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Purchase Date" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.purchase_date ||
                                  _vm.deviceDetailData.purchaseDate
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Warranty End" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.warranty_end_date ||
                                  _vm.deviceDetailData.warrantyEndDate
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Zoho Order" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.deviceDetailData.zoho_order_id ||
                                _vm.deviceDetailData.zohoOrderId ||
                                "N/A"
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Created", span: 2 } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.created_at ||
                                  _vm.deviceDetailData.createdAt
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Notes", span: 2 } },
                        [_vm._v(_vm._s(_vm.deviceDetailData.notes || "N/A"))]
                      ),
                    ],
                    1
                  )
                : !_vm.deviceDetailLoading
                ? _c("el-empty", { attrs: { description: "Device not found" } })
                : _vm._e(),
              _vm.deviceDetailData
                ? [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("Device Features")]
                    ),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.deviceFeaturesLoading,
                            expression: "deviceFeaturesLoading",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.deviceFeatures,
                          border: "",
                          size: "small",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "Feature" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        row.feature?.name || row.featureKey
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1694982170
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Duration", width: "130" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        row.durationType === "permanent"
                                          ? "Permanent"
                                          : `${row.durationValue || ""} ${
                                              row.durationType
                                            }`
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3030574514
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Status", width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            row.endDate &&
                                            new Date(row.endDate) < new Date()
                                              ? "danger"
                                              : "success",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.endDate &&
                                                new Date(row.endDate) <
                                                  new Date()
                                                ? "Expired"
                                                : "Active"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2744516449
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "End Date", width: "140" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        row.endDate
                                          ? _vm.formatDate(row.endDate)
                                          : "N/A"
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1452421928
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm.deviceFeatures.length === 0 &&
                    !_vm.deviceFeaturesLoading
                      ? _c("el-empty", {
                          attrs: {
                            description: "No features assigned",
                            "image-size": 60,
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deviceDetailVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }